import {Category} from "../types";

export function getGeneralAverage(categories: Category[]){
    console.log(categories)
    if (categories.length === 0) return -1;

    let total = 0;
    let sumCoefficients = 0;

    for (const { weighted_average, coefficient } of categories) {
        if (weighted_average != -1){
            total += weighted_average * coefficient;
            sumCoefficients += coefficient;
        }
    }

    return sumCoefficients === 0 ? -1 : (total / sumCoefficients).toFixed(2);
}